<div class="main-container">
  <!-- <div class="sider">
    <div class="logo">JiYue Vision</div>
    <div class="thumbnails-box">
      <div class="des">2023/08/21 15:15</div>
      <div class="series">CT: 8 serise</div>
      <ul>
        <li class="active">
          <img src="../../../assets/thum.jpg" alt="" />
        </li>
      </ul>
    </div>
  </div> -->
  <div class="viewer">
    <iframe [src]="safeUrl" frameborder="0" width="100%" height="100%"></iframe>
  </div>
  <div class="reporter">
    <div class="header">
      <div class="title">待报告</div>
      <div class="btns">
        <button nz-button nzType="link" (click)="closeAndUnlockModal()" *ngIf="showRecallBtn()" style="color: #d8d8d8">
          <!-- 解锁图标 -->
          <i nz-icon nzType="unlock" nzTheme="outline"></i>解锁
        </button>
        <!-- 关闭 -->
        <button nz-button nzType="link" (click)="closeModal()" *ngIf="!showRecallBtn()" style="color: #d8d8d8"><i nz-icon nzType="close" nzTheme="outline"></i>关闭</button>
      </div>
    </div>
    <div class="info">
      <div class="t">患者信息</div>
      <div class="box">
        <div class="item">
          <div nz-row>
            <div nz-col nzSpan="8"><span class="label">姓名：</span>{{ caseDetail.patientName }}</div>
            <div nz-col nzSpan="8"><span class="label">性别：</span>{{ genderMap(caseDetail.patientGender) }}</div>
            <div nz-col nzSpan="8"><span class="label">年龄：</span>{{ caseDetail.patientAge }}</div>
          </div>
        </div>
        <div class="item">
          <div nz-row>
            <div nz-col nzSpan="8"><span class="label">检查部位：</span>{{ caseDetail.bodyPartExamined }}</div>
            <!-- <div nz-col nzSpan="16"><span class="label">扫描方式：</span>{{ caseDetail.patientName }}</div> -->
          </div>
        </div>
      </div>
      <div class="t">临床医嘱</div>
      <div class="box txt">无</div>
    </div>
    <div class="report-input-area">
      <div class="t">影像学表现</div>
      <div class="box">
        <textarea nz-input [(ngModel)]="caseDetail.reportDescribe" placeholder="请输入影像学表现..." [nzAutosize]="{ minRows: 6, maxRows: 6 }"></textarea>
      </div>
      <div class="t">影像学结论</div>
      <div class="box">
        <textarea nz-input [(ngModel)]="caseDetail.reportDiagnose" placeholder="请输入影像学结论.." [nzAutosize]="{ minRows: 6, maxRows: 6 }"></textarea>
      </div>
    </div>
    <div class="submit-box">
      <button nz-button nzType="default" style="width: 35%" (click)="saveReport()">保存</button>
      <button nz-button nzType="primary" style="width: 55%" (click)="submitReport()" *ngIf="showSubmitBtn()">提交</button>
      <button nz-button nzType="primary" style="width: 55%" (click)="auditReport()" *ngIf="showAuditBtn()">审核通过</button>
      <button nz-button nzType="primary" style="width: 55%" (click)="rejectReport(rejectModal)" *ngIf="showRejectBtn()">驳回</button>
    </div>
  </div>
</div>
<ng-template #rejectModal let-modal>
  <div nz-row>
    <div nz-col nzFlex="auto">
      <input nz-input placeholder="请输入驳回原因" [(ngModel)]="rejectReason" />
    </div>
  </div>
</ng-template>
